/**
 * Formato de celda coherente con plantillas mayoristas (p. ej. Falabella eOD): fechas como texto DD-MM-YYYY,
 * igual que Excel Chile suele mostrar en archivos fuente.
 */

/**
 * @param {Date} d
 * @returns {string}
 */
function formatDdMmYyyy(d) {
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const y = d.getFullYear();
  return `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${y}`;
}

/**
 * Intenta interpretar cadenas de fecha típicas de Excel / SheetJS (`3/4/26`, `04-03-2026`, ISO).
 * @param {string} s
 * @returns {Date|null}
 */
export function tryParseBulkExcelDateString(s) {
  const t = String(s).trim();
  if (!t) return null;

  // ISO YYYY-MM-DD (sin UTC: construir fecha local para no correr un día)
  const isoYmd = t.match(/^(\d{4})-(\d{2})-(\d{2})(?:[Tt ].*)?$/);
  if (isoYmd) {
    const d = new Date(Number(isoYmd[1]), Number(isoYmd[2]) - 1, Number(isoYmd[3]));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // DD-MM-YYYY (Chile / plantilla usuario)
  let m = t.match(/^(\d{1,2})-(\d{1,2})-(\d{4})(?:\s|$)/);
  if (m) {
    const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  // M/D/YY, M/D/YYYY — SheetJS suele devolver barras estilo Excel
  if (/^\d{1,2}[\/\.]\d{1,2}[\/\.]\d{2,4}(\s|$)/.test(t)) {
    const d = new Date(t);
    if (!Number.isNaN(d.getTime())) return d;
  }

  return null;
}

/**
 * ¿Parece solo una fecha (evita tocar cabeceras alfanuméricas, SKUs, etc.)?
 * @param {string} s
 */
function looksLikeStandaloneDateText(s) {
  const t = String(s).trim();
  if (!t || t.length > 40) return false;
  if (/[a-zA-ZÁÉÍÓÚÑáéíóúñ]/.test(t)) return false;
  return (
    /^\d{4}-\d{2}-\d{2}/.test(t) ||
    /^\d{1,2}-\d{1,2}-\d{4}/.test(t) ||
    /^\d{1,2}[\/\.]\d{1,2}[\/\.]\d{2,4}/.test(t)
  );
}

/**
 * Normaliza una celda parseada desde Excel para almacenar fechas como texto DD-MM-YYYY.
 * Cabeceras y demás texto no se modifican.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeBulkExcelCellDisplay(value) {
  if (value == null || value === '') return '';
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    return formatDdMmYyyy(value);
  }

  const s = String(value).trim();
  if (!s) return '';

  if (!looksLikeStandaloneDateText(s)) return s;

  const parsed = tryParseBulkExcelDateString(s);
  if (!parsed || Number.isNaN(parsed.getTime())) return s;
  return formatDdMmYyyy(parsed);
}
